export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
};

export const categories: Category[] = [
  {
    slug: "downfall",
    name: "明星塌房",
    desc: "人设与口碑的急速反转，记录事件脉络与后续进展。",
    icon: "ri-emotion-unhappy-line",
    count: 214,
  },
  {
    slug: "history",
    name: "艺人黑历史",
    desc: "被重新翻出的旧访谈、早期作品与争议片段梳理。",
    icon: "ri-history-line",
    count: 168,
  },
  {
    slug: "insider",
    name: "娱乐圈内幕",
    desc: "剧组、经纪与商务合作的行业观察与幕后故事。",
    icon: "ri-shield-keyhole-line",
    count: 132,
  },
  {
    slug: "romance",
    name: "恋情风云",
    desc: "同框、行程与官宣，感情线相关话题的持续追踪。",
    icon: "ri-heart-3-line",
    count: 156,
  },
  {
    slug: "variety",
    name: "综艺瓜田",
    desc: "综艺录制花絮、剪辑争议与嘉宾互动的讨论现场。",
    icon: "ri-live-line",
    count: 98,
  },
];